import ArrowButton from './Buttons/ArrowButton';
import { slideRight } from '../../utils/ui';
import React, { useRef } from 'react';
import { Box, SxProps } from '@mui/material';
//* Styles
import './SingleLineContainer.css';

const scrollShift = 240;

interface IProps {
  children: React.ReactNode;
  additionalStyle?: SxProps;
  showOnEarnMoreBanners?: boolean;
}

const SingleLineArrowContainer: React.FunctionComponent<IProps> = ({
  children,
  additionalStyle,
  showOnEarnMoreBanners = false
}: IProps) => {
  const ref = useRef(null);
  const getArrowButtonStyle = (isRight?: boolean) => {
    return {
      position: 'absolute',
      top: showOnEarnMoreBanners ? '45%' : { xs: '154px', md: '226px' },
      ...(isRight && {
        right: showOnEarnMoreBanners ? { xs: '-15px', md: '30px' } : { xs: 0, md: '70px' }
      }),
      ...(!isRight && {
        left: showOnEarnMoreBanners ? { xs: '-15px', md: '-20px' } : { xs: 0, md: '70px' }
      }),
      zIndex: 4,
      display: 'flex'
    } as SxProps;
  };

  return (
    <Box
      className="single-line-container"
      sx={{
        gap: { xs: '7px', md: '10px' },
        ...additionalStyle
      }}
      ref={ref}
    >
      <ArrowButton handleClick={() => slideRight(ref, -scrollShift)} sx={getArrowButtonStyle()} />
      {children}
      <ArrowButton
        isRight
        handleClick={() => slideRight(ref, scrollShift)}
        sx={getArrowButtonStyle(true)}
      />
    </Box>
  );
};

export default SingleLineArrowContainer;
